var path = 'src/app/patients/consultants/consultants.html';
var html = "<h1 class=page-header>Consultants</h1> <div patient-consultants-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/consultants/consultants.html
 ** module id = 406
 ** module chunks = 0
 **/